import { getLocale } from "../runtime";

const sv_iconclose = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Stäng`
};

const iconclose = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconclose(inputs)
	return "iconClose";
};

export { iconclose as "iconClose" };